import React from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export const renderResponsivePaginationItem = (mobileBreakpoint = 768, prevLabel = 'Previous', nextLabel = 'Next') => {
    return (_, type, originalElement) => {
        if (window?.innerWidth < mobileBreakpoint) {
            return originalElement;
        }

        if (type === 'prev') {
            return React.createElement(
                Button,
                {
                    icon: React.createElement(LeftOutlined),
                    iconPlacement: 'start',
                    variant: 'filled',
                },
                prevLabel,
            );
        }

        if (type === 'next') {
            return React.createElement(
                Button,
                {
                    icon: React.createElement(RightOutlined),
                    iconPlacement: 'end',
                    variant: 'filled',
                },
                nextLabel,
            );
        }

        return originalElement;
    };
};
